
<template>
    <div style="padding: 20px;">
        <div style="font-size:14px;margin-top:10px;margin-bottom: 20px;" >
            <el-row :sm="24" :lg="24" >
                <el-col :span="7">车牌号
                    <el-select v-model="value" style="width:74px" size="small" placeholder="全部"  >
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <el-input
                    style="width:150px"
                    size="small"
                    clearable
                    v-model.trim="vehicleNumber"
                    placeholder="请输入车牌号"
                    ></el-input>
                </el-col>
                <el-col :span="2">
                    <el-button @click="getListData(true)" size="small"  style="width:66px;font-size:14px;" >查询</el-button>
                </el-col>  
            </el-row>
        </div>
        <div style="padding:14px;background: #fff;">
            <div style="display: flex;justify-content: space-between;align-items: center;padding-bottom: 10px;">
                <div class="span_but">
                    <span style="font-weight: 550;cursor: default;display: inline-block;width: 210px;">数据截止时间：{{dateTime!=''?dateTime.slice(0,4)+'年'+dateTime.slice(4)+'月':'' }}</span>
                    <span @click="switchBut(0)" :class="orderType==0?'span_current':''">按办卡量排序</span>
                    <span @click="switchBut(1)" :class="orderType==1?'span_current':''">按消费量排序</span>
                    <span @click="switchBut(2)" :class="orderType==2?'span_current':''">按获取优惠金额排序</span>
                </div>
                <div>
                   <el-button v-show="hideExport" style="margin-left:20px;" @click="exportDate">导出</el-button>
                </div>
            </div>
            <div style="">
                <el-table ref="singleTable" border empty-text="暂无相关信息" :header-cell-style="{background:'#eef1f6',color:'#606266'}" :data="listData" height="58vh"  stripe  style="width: 100%" >
                    <el-table-column property="vehicleNumber" label="车牌号" width="150"  align="center">
                        <template slot-scope="scope">
                            <div style="display: flex;align-items: center;justify-content: center;flex-direction: column;">
                                <span style="font-weight: 550;cursor: default;">{{scope.row.vehicleNumber}}</span>
                                <span @click="carCardDetails(scope.row.carNumber)" style="color: #4e8ed6;">办卡明细</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column property="totalCardCount" label="办卡数量（张）" align="center" >
                        <template slot-scope="scope">
                            <div class="span_count">
                                <div class="span_item">
                                    <span style="color:#41B883;font-weight: 550;">{{format(scope.row.totalCardCount)}}</span>
                                    <span class="font_14">合计</span>
                                </div>
                                <div class="span_item">
                                    <span style="font-weight: 550;">{{format(scope.row.singleCardCount)}}</span>
                                    <span class="font_14">单卡</span>
                                </div>
                                <div class="span_item">
                                    <span style="font-weight: 550;">{{format(scope.row.mainCardCount)}}</span>
                                    <span class="font_14">主副卡</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column property="totalCardLitter" label="持卡消费量（吨）"  align="center">
                        <template slot-scope="scope">
                            <div class="span_count">
                                <div class="span_item">
                                    <span style="color:#41B883;font-weight: 550;">{{format(scope.row.totalCardLitter)}}</span>
                                    <span class="font_14">合计</span>
                                </div>
                                <div class="span_item">
                                    <span style="font-weight: 550;">{{format(scope.row.singleCardLitter)}}</span>
                                    <span class="font_14">单卡</span>
                                </div>
                                <div class="span_item">
                                    <span style="font-weight: 550;">{{format(scope.row.mainCardLitter)}}</span>
                                    <span class="font_14">主副卡</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column property="totalCardAmount" label="获取优惠金额（元）" align="center" >
                        <template slot-scope="scope">
                            <div class="span_count">
                                <div class="span_item">
                                    <span style="color:#41B883;font-weight: 550;">{{format(scope.row.totalCardAmount)}}</span>
                                    <span class="font_14">合计</span>
                                </div>
                                <div class="span_item">
                                    <span style="font-weight: 550;">{{format(scope.row.singleCardAmount)}}</span>
                                    <span class="font_14">单卡</span>
                                </div>
                                <div class="span_item">
                                    <span style="font-weight: 550;">{{format(scope.row.mainCardAmount)}}</span>
                                    <span class="font_14">主副卡</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div style="margin-top: 10px;display: flex;justify-content: center;">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="pageNo"
                    :page-size="pageSize"
                    layout="total,prev, pager, next,sizes, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
  
</template>

<script>
import Cookies from 'js-cookie'
import http from '@/api/cardData'
import { hideExport } from '@/utils/tools'
export default {
     data () {
        return {
            hideExport:hideExport,
            pageNo:1,
            pageSize:20,
            total:0,
            dateTime:'',
            orderType:0,
            vehicleNumber:'',
            listData:[],
            options: [
                    {value: '全部',label: '全部'},
                    {value: '京',label: '京'}, 
                    {value: '津',label: '津'},
                    {value: '冀',label: '冀'}, 
                    {value: '晋',label: '晋'},
                    {value: '蒙',label: '蒙'},
                    {value: '辽',label: '辽'},
                    {value: '吉',label: '吉'}, 
                    {value: '黑',label: '黑'},
                    {value: '沪',label: '沪'},
                    {value: '苏',label: '苏'},
                    {value: '浙',label: '浙'}, 
                    {value: '皖',label: '皖'},
                    {value: '闽',label: '闽'},
                    {value: '赣',label: '赣'},
                    {value: '鲁',label: '鲁'}, 
                    {value: '豫',label: '豫'},
                    {value: '鄂',label: '鄂'},
                    {value: '湘',label: '湘'},
                    {value: '粤',label: '粤'}, 
                    {value: '桂',label: '桂'},
                    {value: '琼',label: '琼'},
                    {value: '渝',label: '渝'},
                    {value: '川',label: '川'}, 
                    {value: '贵',label: '贵'},
                    {value: '云',label: '云'},
                    {value: '藏',label: '藏'}, 
                    {value: '陕',label: '陕'},
                    {value: '甘',label: '甘'},
                    {value: '青',label: '青'}, 
                    {value: '宁',label: '宁'},
                    {value: '新',label: '新'},
                     
                ],
            value: '全部'
        }
    },
    watch:{
        vehicleNumber:function(){
            this.vehicleNumber = this.vehicleNumber.toUpperCase();
        }
    },
    
    mounted() {
        if(sessionStorage.getItem('isAlive')==1){
            let dt = JSON.parse(sessionStorage.getItem('objData'));
            this.pageNo = dt.pageNo;
            this.value = dt.value;
            this.vehicleNumber = dt.vehicleNumber;
            this.orderType = dt.orderType;
            this.pageSize = dt.pageSize;
        }
        this.getListData();
        sessionStorage.setItem('isAlive',0)
        this.$nextTick(()=>{
            document.getElementsByClassName('el-select-dropdown__list')[0].setAttribute('style', 'width: 330px !important;display: flex !important;flex-wrap: wrap !important;');
        })
    },
    methods: {
        getListData(search = false){
            if(search){
                if(this.value!='全部'&&this.vehicleNumber.length<5||this.value=='全部'&&this.vehicleNumber!=''){
                    this.$message.error('请先输入有效的车牌号');
                    return false;
                }
            }
                
            let carCity = this.value == '全部' ? '' : this.value
            http[0].cardCountList({
                vehicleNumber: carCity + this.vehicleNumber,
                page:this.pageNo,
                pageSize:this.pageSize,
                order:this.orderType
            }).then(e=>{
                this.total = e.data.total;
                this.listData = e.data.rows;
                this.dateTime = e.data.rows[0]&&e.data.rows[0].date||'';
            })
        },
        switchBut(a){
            this.orderType = a;
            this.getListData();
        },
        carCardDetails(a){
            let obj = {
                value:this.value,
                vehicleNumber:this.vehicleNumber,
                orderType:this.orderType,
                pageNo:this.pageNo,
                pageSize:this.pageSize,
            }
            sessionStorage.setItem('objData',JSON.stringify(obj))
             this.$router.push({
                name: 'cardDetails',
                query: {
                    carNum:a,
                    time:this.dateTime
                }
            })
        },
        //修改每页条数
        handleSizeChange(e){
            this.pageSize = e;
            this.pageNo = 1;
            this.getListData();
        },
        //点击页码
        handleCurrentChange(e){
            this.pageNo = e;
            this.getListData();
        },
        exportDate(){
            let veNum = '';
            if(this.vehicleNumber&&this.vehicleNumber.length>5){
                let carcy = this.value=='全部'?'':this.value;
                veNum = carcy + this.vehicleNumber;
            } 
            window.location.assign(`/bi-api/vehicleCardCount/cardCountListExport?order=${this.orderType}&vehicleNumber=${veNum}`)
        },
        format(num) {
            var res=num.toString().replace(/\d+/, function(n){ // 先提取整数部分
                return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
                    return $1+",";
                });
            })
            return res;
        },
    }
}
</script>

<style scoped>
.span_but span{
    margin-right: 30px;
    font-size: 14px;
}
.span_current{
    color: #4e8ed6;
}
.span_count{
    display: flex;
    align-items: center;
    justify-content: space-around;
}
.span_item{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    
}
.span_item span{
    cursor: default;
}
.span_item .font_14{
    color: #999;
    font-size: 12px;
}

</style>
